import { render, staticRenderFns } from "./alarmRecord.vue?vue&type=template&id=71a384a6&scoped=true&"
import script from "./alarmRecord.vue?vue&type=script&lang=js&"
export * from "./alarmRecord.vue?vue&type=script&lang=js&"
import style0 from "./alarmRecord.vue?vue&type=style&index=0&id=71a384a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a384a6",
  null
  
)

export default component.exports